import SupportTicketConfig from "./SupportTicketConfig";

export default class SupportTicketService {
	static setSupportTicket(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = SupportTicketConfig.endpoint;
				let response = await SupportTicketConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateSupportTicket(id, value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = SupportTicketConfig.endpoint;
				let response = await SupportTicketConfig.APIConnector.put(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static deleteSupportTicket(supportTicketId, supportTicket) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = SupportTicketConfig.endpoint + "/" + supportTicketId;
				let response = SupportTicketConfig.APIConnector.delete(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getSupportTicketList(searchText, page, size) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = SupportTicketConfig.endpoint;
				if (searchText) endpoint += "?searchText=" + searchText;
				if (searchText && page && size)
					endpoint += "&page=" + page + "&size=" + size;
				else if (page && size) endpoint += "?page=" + page + "&size=" + size;
				let response = await SupportTicketConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getUsersSupport() {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = SupportTicketConfig.endpointGetUsersSupport;
				let response = SupportTicketConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/SupportTicket/SupportTicketService.js